import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_ATTACHMENTYPE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.attachmentType = payload
  },
  [types.SET_ATTACHMENTYPES] (state, payload) {
    state.attachmentTypes = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  }
}
